/**
 * Extracts the URL pathname, stripping the origin for compact logging.
 */
export function extractFetchUrlPath(url: string): string {
  try {
    return new URL(url).pathname;
  } catch {
    return url;
  }
}
